import { h } from 'preact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

export const Icon = ({ class: className, style, onClick, ...props }) => (
    <span class={classNames(className, 'centerer')} onClick={onClick} style={style}><FontAwesomeIcon {...props} /></span>
);